/** A stored Variable 2 selection: the variable it belongs to, and the option chosen. */
export interface AdditionalVariableSelection {
  variableId: unknown;
}

/**
 * Keep a stored Variable 2 selection only while its variable still applies to the product. The variable is
 * scoped by brand, Product Type and categories 1 and 2, so a change to any of them can leave the selection
 * pointing at a variable the product no longer matches.
 * @param selection the product's stored selection
 * @param matched the variables that match the product's current brand, type and categories
 * @returns the selection when its variable is still matched, otherwise null
 */
export const reconcileAdditionalVariable = <T extends AdditionalVariableSelection>(selection: T | null | undefined, matched: ReadonlyArray<{ _id: unknown }>): T | null =>
  selection && matched.some((variable) => String(variable._id) === String(selection.variableId)) ? selection : null;
